// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1sCG6","filesListContainer":"PosDisputesFiles_filesListContainer__3S510","filesButton":"PosDisputesFiles_filesButton__1KBgd"};